/*!
 * IE10 viewport hack for Surface/desktop Windows 8 bug
 * Copyright 2014-2017 The Bootstrap Authors
 * Copyright 2014-2017 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */

// See the Getting Started docs for more information:
// https://getbootstrap.com/getting-started/#support-ie10-width

(function($) {
    'use strict';

    var natopsAjax  = null;
    var ajaxTimeout = null;

    var resizeMainNavDropdown = function() {
        var $container = $('#site-header .container');
        var containerWidth = $container.outerWidth();

        $('.dropdown-menu').each(function() {
            var $dropdown = $(this);
            var dropdownWidth =
                $dropdown.find('.menu-item').length *
                    ($dropdown
                        .find('.menu-item')
                        .first()
                        .outerWidth() +
                        1) +
                29;

            if (dropdownWidth > containerWidth) {
                dropdownWidth = containerWidth;
            }

            $dropdown.width(dropdownWidth);
        });
    };

    var realignDropdownMenu = function($dropdown) {
        var $container = $('#site-header .container');
        var containerWidth = $container.outerWidth();
        var $mainNav = $('.js-main-nav');
        var mainNavWidth = $mainNav.outerWidth();
        var mainNavOffsetLeft = $mainNav.offset().left;
        var mainNavOffsetRight = mainNavOffsetLeft + mainNavWidth;
        var containerOffsetRight = $container.offset().left + containerWidth;

        // Horizontally align by default
        $dropdown.css({
            marginLeft: '-' + $dropdown.outerWidth() / 2 + 'px',
            left: '50%'
        });

        var dropdownOffsetLeft  = $dropdown.offset().left;
        var dropdownOffsetRight = dropdownOffsetLeft + $dropdown.outerWidth();
        var $parentMenuItem     = $dropdown.closest('.menu-item');

        // If it's overflowing to the right/left, then we anchor it to the right
        if (
            dropdownOffsetRight > mainNavOffsetRight ||
            dropdownOffsetLeft < mainNavOffsetLeft
        ) {
            $dropdown.css({
                marginLeft: 0,
                left: 'auto',
                right: 0
            });

            $dropdown.css({
                right:
                    $dropdown.offset().left +
                    $dropdown.outerWidth() -
                    containerOffsetRight
            });

            if ($parentMenuItem.index('.js-main-nav > .menu-item') === 0) {
                $dropdown.css({
                    right: 'auto',
                });
            }
        }
    };

    var loadNatOps = function () {
        var template  = $('#js-natops-item').html();
        var $loader   = $('.js-natops-loader');
        var $list     = $('.js-natops-list');

        Mustache.parse(template);

        var data = {
            nonce: rissb_var.nonces.get_natops,
        };

        if (window.matchMedia('(max-width: 768px)').matches) {
            data.filters = $('.filter-mobile .js-natops-filters :input').serialize();
        } else {
            data.filters = $('.filter-desktop .js-natops-filters :input').serialize();
        }

        $loader.removeClass('d-none');
        $list.empty();

        if (natopsAjax) {
            natopsAjax.abort();
        }

        natopsAjax = $.post('/api/natops', data, function (res) {
            var rendered = Mustache.render(template, res.data);

            $loader.addClass('d-none')
            $list.html(rendered);
        });
    };

    $(window).on('load resize', resizeMainNavDropdown);

    $(document).ready(function() {
        if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
            var msViewportStyle = document.createElement('style');
            msViewportStyle.appendChild(
                document.createTextNode('@-ms-viewport{width:auto!important}')
            );
            document.head.appendChild(msViewportStyle);
        }

        $('[data-toggle="offcanvas"]').on('click', function() {
            $('.offcanvas').toggleClass('active');
            $('.footer').toggleClass('active');
        });

        if ($('.js-list-products-queue').length && $('body').hasClass('logged-in')) {
            RISSB.fn.loadQueue();
        }

        // $('.js-clear-queue').on('click', function (e) {
        //     e.preventDefault();

        //     $.post('/api/products/queue/clear', {
        //         nonce: rissb_var.nonces.clear_queue,
        //     }, function (res) {
        //         RISSB.fn.loadQueue();
        //     });
        // });

        $('.js-download-queue').on('click', function () {
            $('.js-list-products-queue').html('<span class="font-size-small">Selected poducts have been downloaded, please check your browsers downloads.</span>');
        });

        $('.post-content').fitVids();

        $(document).on('click', '.js-main-nav > li > .nav-link', function(e) {
            e.preventDefault();

            var $this = $(this);
            var $dropdown = $this.closest('li').find('.dropdown-menu');

            $('.js-main-nav > li > .nav-link')
                .not($this)
                .removeClass('active');
            $('.js-main-nav')
                .find('.dropdown-menu')
                .not($dropdown)
                .removeClass('show');
            $this
                .closest('li')
                .find('.dropdown-menu')
                .toggleClass('show');
            $this.toggleClass('active');

            realignDropdownMenu($dropdown);
        });

        $('.js-close-main-nav-dropdown').on('click', function() {
            var $this = $(this);

            $this.closest('.dropdown-menu').toggleClass('show');
            $this
                .closest('li')
                .find('.nav-link')
                .removeClass('active');
        });

        $(document).on('click', function(e) {
            if ($(e.target).closest('.menu-primary-menu-container').length) {
                return;
            }

            $('.js-main-nav .dropdown-menu').removeClass('show');
            $('.js-main-nav > li > .nav-link').removeClass('active');
        });

        // Off canvas menu
        $('.sidebar-offcanvas .nav-link').on('click', function() {
            var $this = $(this);
            $this.next('.dropdown-menu').slideToggle();
        });

        if ($('body').hasClass('page-id-' + rissb_var.pages.modal_video) || $('body').hasClass('page-template-template-webinar')) {
            $('.site-main a').each(function() {
                if (this.href.indexOf('.mp4') != -1 || this.href.indexOf('.m4v') != -1) {
                    var video = this;
                    video.setAttribute('data-featherlight', "iframe");
                    video.setAttribute('data-featherlight-iframe-width', "640");
                    video.setAttribute('data-featherlight-iframe-height', "480");
                    video.setAttribute('data-featherlight-iframe-frameborder', "0");
                    video.setAttribute('data-featherlight-iframe-allow', "autoplay; encrypted-media");
                    video.setAttribute('data-featherlight-iframe-allowfullscreen', "true");
                }
            });

            var current = $.featherlight.current();
            current.close();
            $.featherlight({iframe: 'editor.html', iframeMaxWidth: '80%', iframeWidth: 500, iframeHeight: 300});
        }

        if ($('.accordion').length) {
            $('.collapse').on('show.bs.collapse hide.bs.collapse', function (e) {
                $('[data-target="#' + e.target.id + '"]').closest('.accordion-header').toggleClass('is-active', e.type === 'show');
            });
        }

        if ($('.js-natops-list').length) {
            loadNatOps();

            $('.js-natops-filters').find('input[name="search_in[]"]').on('change', function () {
                var $this = $(this);

                RISSB.fn.updateQSParams('search_in[]', $this.closest('.js-natops-filters').find('input[name="search_in[]"]:checked').map(function () {
                    return $(this).val();
                }).get(), true);

                loadNatOps();
            });

            $('.js-natops-filters').find('.js-natops-search').on('keyup input', function () {
                clearTimeout(ajaxTimeout);
                ajaxTimeout = setTimeout(loadNatOps, 500);
            });
        }
    });
})(jQuery);
